import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { forkJoin, map, Observable } from 'rxjs';

interface II18n {
  translationKey: string;
  translation: string;
}

export class CustomeTranslateHttpLoader implements TranslateLoader {
  i18nController: string = 'api/I18n';
  constructor(
    private http: HttpClient,
    public prefix: string = '/assets/i18n/',
    public suffix: string = '.json'
  ) {}

  /**
   * Gets the translations from the server
   */
  public getTranslation(lang: string): Observable<Object> {
    return forkJoin({
      fa: this.http.get<{ [key: string]: string }>(
        `${this.prefix}${lang}${this.suffix}`
      ),
      // fb: this.http.get<II18n[]>(
      //     `${this.i18nController}?languageCode=${lang}`
      // ),
    }).pipe(
      map((res) => {
        const retArray = {
          ...res.fa,
          // ...res.fb.reduce(
          //     (acc, value) => ({
          //         ...acc,
          //         [value.translationKey]: value.translation,
          //     }),
          //     {}
          // ),
        };
        return retArray;
      })
    );
  }
}
